<template>
  <span
    :class="hasStatus ? ['status-badge', `status-badge--${resolvedVariant}`] : 'status-badge-empty'"
    :data-status="hasStatus ? normalizedStatus : null"
  >
    <span v-if="hasStatus" class="status-badge__label">{{ displayLabel }}</span>
    <span v-else>—</span>
  </span>
</template>

<script>
import { normalizeStatus, statusVariant } from '@/utils/statusVariants';

const VALID_VARIANTS = ['success', 'warning', 'danger', 'info', 'neutral'];

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: [String, Number],
      default: '',
    },
    variant: {
      type: String,
      default: '',
      validator: (value) => !value || VALID_VARIANTS.includes(value),
    },
  },
  computed: {
    normalizedStatus() {
      return normalizeStatus(this.status);
    },
    resolvedVariant() {
      return this.variant || statusVariant(this.status);
    },
    hasStatus() {
      if (this.status === null || this.status === undefined) return false;
      const value = String(this.status).trim();
      if (!value) return false;
      return !['unavailable', 'n/a', 'na'].includes(normalizeStatus(value));
    },
    displayLabel() {
      return this.label === '' || this.label === null || this.label === undefined
        ? this.status
        : this.label;
    },
  },
};
</script>

<style scoped>
.status-badge {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 600;
  gap: 0.38rem;
  line-height: 1.2;
  max-width: 100%;
  min-height: 1.75rem;
  padding: 0.28rem 0.65rem;
  white-space: nowrap;
}

.status-badge__label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-badge-empty {
  color: inherit;
}

.status-badge--success {
  background: #e8f7ed;
  border-color: #c8e9d2;
  color: #176b35;
}

.status-badge--warning {
  background: #fff6dc;
  border-color: #f1dda0;
  color: #765507;
}

.status-badge--danger {
  background: #fdecef;
  border-color: #f3c8d0;
  color: #a31331;
}

.status-badge--info {
  background: #e8f3fc;
  border-color: #c8dff2;
  color: #175d91;
}

.status-badge--neutral {
  background: #f0f3f5;
  border-color: #dce2e7;
  color: #4b5d6d;
}
</style>
